var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    fill: "#DD3782",
    viewBox: "0 0 404.547 491.52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M798.906 1314.77h196.973c142.971-132.14 324.101-211.16 521.171-211.16 166.62 0 321.84 86.38 452.25 211.16h265.89c439.4 0 798.91-359.504 798.91-798.911V0H0v515.859c0 439.407 359.508 798.911 798.906 798.911",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2314.88 2647.48c24.73-131.33 28.46-355.86 9.82-493.76-27.74-205.36-108.22-389.65-223.92-531.42-148.56-182.01-354.88-294.6-583.73-294.6-228.85 0-435.16 112.59-583.726 294.6-115.789 141.88-196.297 326.32-223.988 531.86-18.566 137.8-14.816 362.11 9.891 493.32l150.597-28.19c-23.086-122.58-25.035-343.02-4.41-471.25 26.758-166.36 93.234-314.6 186.716-429.13 119.81-146.81 284.25-237.61 464.92-237.61 180.67 0 345.11 90.8 464.93 237.61 94.12 115.32 160.87 264.81 187.25 432.57 20.04 127.42 17.95 346.2-4.96 467.81l150.61 28.19",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1517.05 3686.4 1383.03-396.76-346.16-99.3c-10.65 26.63-35.82 46.05-66.03 48.13l-891.45 123.93c-21.7 17.6-50.66 27.46-79.39 27.46-57.13 0-115.2-39.04-115.2-100.22 0-61.17 58.07-100.21 115.2-100.21 24.18 0 48.52 6.99 68.56 19.69l691.36-98.23-759.92-218-1383.038 396.75L1517.05 3686.4",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2348.63 3071.53v-472.46c0-38.87-44.13-66.78-97.45-70.7l-735.17-56.57-733.088 56.57c-53.277 4.11-97.449 31.82-97.449 70.7v472.46l831.577-238.56 831.58 238.56m-831.58 156.29c42.3 0 76.8 27.78 76.8 61.82 0 34.06-34.5 61.82-76.8 61.82s-76.8-27.76-76.8-61.82c0-34.04 34.5-61.82 76.8-61.82",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.8 3327.89c-21.12 1.33-39.32-14.72-40.65-35.84-1.32-21.13 14.73-39.33 35.85-40.65l883.2-125.49v-667.73c0-21.2 17.19-38.39 38.39-38.39 21.21 0 38.41 17.19 38.41 38.39v703.67h-.01c.02 20.1-15.6 37.02-35.93 38.32l-.06-.07-919.2 127.79",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2478.58 2403.57c32.4 0 58.83 26.43 58.83 58.82 0 32.4-26.43 58.82-58.83 58.82s-58.82-26.42-58.82-58.82c0-32.39 26.42-58.82 58.82-58.82",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2406.27 2121.66 72.31 398.08 72.32-398.08z",
    style: {
      fill: "#DD3782",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 491.52)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.13e6824cc15a1b8dcc953c742230e487.svg";
export { ForwardRef as ReactComponent };